import { Command } from "./Command";

export default class ConfirmAccountCommand extends Command {
    code: string
    constructor(code: string) {
        super()
        this.code = code
    }
}